import myaxios from "../../components/Axios";

export const getSingleProcessService = (id) => myaxios.get(`/ajax/processbuilder/${id}`)
export const updateSingleProcessService = (id, data) => myaxios.put(`/ajax/processbuilder/${id}`, data)